import {Component, OnInit} from '@angular/core';
import { AuthenticationService } from '../../services/workflow/authentication.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  isLoginError: boolean;
  loginForm: FormGroup;
  submitClick = false;
  submitted = false;

  get formData() { return this.loginForm.controls; }

  constructor(private authenticationService: AuthenticationService, private router: Router, private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.loginForm = this.formBuilder.group ({
      username: ['', Validators.compose([ Validators.required, Validators.maxLength(100) ])],
      password: ['', Validators.compose([ Validators.required, Validators.maxLength(24) ])]
    });
  }

  OnSubmit() {
    this.submitted = true;
    this.submitClick = true;
    this.isLoginError = false;

    if (this.loginForm.invalid) {
      this.submitClick = false;
      return;
    }

    const login = this.loginForm.getRawValue();
    localStorage.setItem('userName', login.username);

    this.authenticationService.getWorkflowLogin(login.username, login.password).subscribe((data: any) => {


          if (data !== null && data.error !== null && data.error) {
            this.isLoginError = true;
            this.submitClick = false;
          } else {
            localStorage.setItem('userToken', data.result.token);
            localStorage.setItem('systemKey', data.result.context.systemKey);
            location.href = '/home';
          }

        },
        (err: HttpErrorResponse) => {
          this.isLoginError = true;
          this.submitClick = false;
        });
  }
}
